import SellerComment from './SellerComment.vue'

export default SellerComment
